/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IAddressBillingHeading {
    text: string;
}

export const AddressBillingHeading: React.FC<IAddressBillingHeading> = ({ text }) => (
    <h2 className='ms-checkout-billing-address__heading'>{text}</h2>
);

export default IAddressBillingHeading;
